export const GATEWAY_URL = `https://gwat-contents.globalworkandtravel.com`;
